<template>
  <v-card v-if="data">
    <v-card-title>{{ data.name }}</v-card-title>
    <v-form @submit.prevent="saveData">
      <v-card-text>
        <v-row>
          <v-col>
            <v-text-field disabled hide-details="auto" label="ID" outlined filled dense v-model="data._id"/>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field hide-details="auto" label="Název" outlined filled dense v-model="data.name"/>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field hide-details="auto" label="Patro" outlined filled dense v-model="data.floor"/>
          </v-col>
          <v-col cols="12" md="4">
            <datetime-picker :text-field-props="{'hide-details': 'auto', filled: true, dense: true}" outlined
                             label="Termín"
                             v-model="data.date"/>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6">
            <v-text-field readonly hide-details="auto" label="Zákazník" outlined filled dense
                          v-model="data.customerEmail"/>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field readonly hide-details="auto" label="Poskytovatel" outlined filled dense
                          v-model="data.providerEmail || 'Není přiřazen'"/>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="7">
            <v-select hide-details="auto"
                      label="Status"
                      outlined
                      filled
                      dense
                      item-text="name"
                      item-value="code"
                      :items="cleaningServiceStatuses"
                      v-model="data.status"/>
          </v-col>
          <v-col cols="12" sm="3">
            <v-select hide-details="auto"
                      label="Typ"
                      outlined
                      filled
                      dense
                      item-text="name"
                      item-value="code"
                      :items="serviceTypes"
                      v-model="data.type"/>
          </v-col>
          <v-col cols="12" sm="2">
            <v-select hide-details="auto"
                      label="Velikost"
                      outlined
                      filled
                      dense
                      item-text="name"
                      item-value="code"
                      :items="dimensionalTypes"
                      v-model="data.dimension"/>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" :sm="(data.addressType === 'CUSTOM' ? 6 : 12)">
            <v-select hide-details="auto"
                      label="Typ adresy"
                      outlined
                      filled
                      dense
                      item-text="name"
                      item-value="code"
                      :items="addressTypes"
                      v-model="data.addressType"/>
          </v-col>
          <v-col v-if="data.addressType === 'CUSTOM'" cols="12" sm="6">
            <address-field :address-id="addressId" label="Adresa"
                           @change="changeAddress"></address-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6">
            <v-select :items="[{name: 'Ano', value: true}, {name: 'Ne', value: false}]"
                      hide-details="auto" label="Vlastní čistící prostředky"
                      outlined filled dense
                      item-text="name"
                      item-value="value"
                      v-model="data.hasDetergents"></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-textarea outlined dense hide-details="auto" filled v-model="data.note" label="Poznámka"
                        rows="2"></v-textarea>
          </v-col>
        </v-row>
        <v-row
            v-if="data.cleaningProcessStartTime || data.cleaningProcessFinishTime || data.preparationStartTime || data.cleaningCompleteStartTime">
          <v-col v-if="data.cleaningProcessStartTime">
            <v-text-field outlined dense hide-details="auto" filled :value="formattedCleaningProcessStartTime"
                          label="Počáteční datum" readonly/>
          </v-col>
          <v-col v-if="data.preparationStartTime">
            <v-text-field outlined dense hide-details="auto" filled :value="formattedPreparationStartTime"
                          label="Datum přípravy" readonly/>
          </v-col>
          <v-col v-if="data.cleaningCompleteStartTime">
            <v-text-field outlined dense hide-details="auto" filled :value="formattedCleaningCompleteStartTime"
                          label="Datum dokončení" readonly/>
          </v-col>
          <v-col v-if="data.cleaningProcessFinishTime">
            <v-text-field outlined dense hide-details="auto" filled :value="formattedCleaningProcessFinishTime"
                          label="Datum ukončení" readonly/>
          </v-col>
        </v-row>
        <v-row v-if="data.totalTime || data.totalPrice">
          <v-col cols="6" v-if="data.totalTime">
            <v-text-field outlined dense hide-details="auto" filled :value="formattedTotalTime" label="Celkový čas"
                          readonly/>
          </v-col>
          <v-col cols="6" v-if="data.totalPrice">
            <v-text-field outlined dense hide-details="auto" filled :value="formattedTotalPrice" label="Cena" readonly/>
          </v-col>
          <v-col cols="6" v-if="data.providerPriceFee">
            <v-text-field outlined dense hide-details="auto" filled :value="formattedProviderPriceFee"
                          label="Poplatek poskytovatele" readonly/>
          </v-col>
          <v-col cols="6" v-if="data.providerPrice">
            <v-text-field outlined dense hide-details="auto" filled :value="formattedProviderPrice"
                          label="Konečný zisk poskytovatele" readonly/>
          </v-col>
          <v-col cols="6" v-if="data.customerPriceFee">
            <v-text-field outlined dense hide-details="auto" filled :value="formattedCustomerPriceFee"
                          label="Poplatek zákazníka" readonly/>
          </v-col>
          <v-col cols="6" v-if="data.customerPrice">
            <v-text-field outlined dense hide-details="auto" filled :value="formattedCustomerPrice"
                          label="Konečná cena pro zákazníka" readonly/>
          </v-col>
        </v-row>
        <v-row v-if="finishedPhotoPath">
          <v-col cols="12">
            <v-img :src="finishedPhotoPath"></v-img>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn outlined small color="primary" to="/app/cleaning-services" exact>Zrušit</v-btn>
        <refund-order-dialog v-if="id" :order-id="id" @refunded="onRefunded">
          <template #default="{ on, attrs }">
            <v-btn
              outlined
              small
              color="warning"
              v-on="on"
              v-bind="attrs"
              class="ml-2"
            >
              Vrátit platbu
            </v-btn>
          </template>
        </refund-order-dialog>
        <refund-cancellation-fee-dialog v-if="id && data.status === 'canceled'" :order-id="id" @refunded="onCancellationFeeRefunded">
          <template #default="{ on, attrs }">
            <v-btn outlined small color="warning" v-on="on" v-bind="attrs" class="ml-2">
              Vrátit storno poplatek
            </v-btn>
          </template>
        </refund-cancellation-fee-dialog>
        <v-spacer></v-spacer>
        <v-btn small color="primary" type="submit">Uložit</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>

import {secondsToTime} from '@/helper/global-helper'
import {API_BASE_URL} from '@/config'
import {formatDatetime} from '@/helper/date-helper'
import RefundOrderDialog from '@/components/app/orders/RefundOrderDialog'
import RefundCancellationFeeDialog from '@/components/app/orders/RefundCancellationFeeDialog'

export default {
  name: "CleaningServiceCardCard",
  components: {
    RefundOrderDialog,
    RefundCancellationFeeDialog
  },
  props: {
    id: {
      required: false,
      default: () => null
    }
  },
  data() {
    return {
      data: null,
      saveModel: {
        address: null,
        customAddress: null,
        detergents: true,
        dimension: null,
        floor: null,
        name: null,
        note: null,
        orderTime: null,
        status: null,
        type: null
      }
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (this.creating) {
        this.data = this.saveModel
        return
      }
      this.data = {}
      this.axios.get('v1/cleaning-orders/' + this.id)
          .then(({data}) => {
            // this.data = data
          })
          // .catch(() => this.$router.go(-1))
    },
    saveData() {
      const saveData = Object.assign({}, this.saveModel)
      this.axios.put('/api/admin/cleaning-service/' + this.id, saveData)
          .then(({data}) => this.data = data.data)
    },
    changeAddress(googlePlaceId) {
      this.saveModel.customAddress = googlePlaceId
    },
    acceptCleaningOrder(){
      this.axios.put('v1/cleaning-orders/' + this.id + '/accept')

    },
    startOrderPreparation(){
      this.axios.put('v1/cleaning-orders/' + this.id + '/start-cleaning')

    },
    completeOrderCleaning(){
      this.axios.put('v1/cleaning-orders/' + this.id + '/complete-cleaning')

    },
    onRefunded(data) {
      this.$store.commit('addAlert', {
        type: 'success',
        message: `Platba ${data.amount} Kč byla úspěšně vrácena`
      })
      // Refresh the order data
      this.getData()
    },
    onCancellationFeeRefunded() {
      // The dialog shows its own success alert; just refresh the order.
      this.getData()
    },
  },
  computed: {
    addressId() {
      if (this.creating) return null
      return this.data.address
    },
    cleaningServiceStatuses() {
      return this.$store.state.types.cleaningServiceStatus
    },
    dimensionalTypes() {
      return this.$store.state.types.dimensionType
    },
    serviceTypes() {
      return this.$store.state.types.serviceType
    },
    addressTypes() {
      return this.$store.state.types.addressType
    },
    formattedTotalPrice() {
      return this.data.totalPrice + ' Kč'
    },
    formattedProviderPriceFee() {
      return this.data.providerPriceFee + ' %'
    },
    formattedProviderPrice() {
      return this.data.providerPrice + ' Kč'
    },
    formattedCustomerPriceFee() {
      return this.data.customerPriceFee + ' %'
    },
    formattedCustomerPrice() {
      return this.data.customerPrice + ' Kč'
    },
    formattedTotalTime() {
      return secondsToTime(this.data.totalTime)
    },
    formattedPreparationStartTime() {
      return formatDatetime(this.data.preparationStartTime)
    },
    formattedCleaningProcessStartTime() {
      return formatDatetime(this.data.cleaningProcessStartTime)
    },
    formattedCleaningProcessFinishTime() {
      return formatDatetime(this.data.cleaningProcessFinishTime)
    },
    formattedCleaningCompleteStartTime() {
      return formatDatetime(this.data.cleaningCompleteStartTime)
    },
    finishedPhotoPath() {
      return this.data && this.data.photoPath ? API_BASE_URL + "/" + this.data.photoPath : null
    }
  },
  watch: {
    data: {
      deep: true,
      handler: function (value) {
        if (!value) return
        Object.keys(value).forEach(key => {
          if (key === 'addressType') {
            this.saveModel['address'] = value[key]
            if (value[key] !== 'CUSTOM')
              this.saveModel.customAddress = null
          } else {
            this.saveModel[key] = value[key]
          }
        })
      }
    }
  }
}
</script>

<style scoped>

</style>